import request from '../../utils/requests'
/** * Tag: OrgDictionary */
const baseUrl ="/api/OrgDictionary";

/** * 新增 * @param {*} body * { *    OrgDictionaryId Desc: Required:false *    BranchId Desc:校区id Required:false *    DicGroup Desc:标签分组 
优秀学生标签：FineStudent;
优秀教师标签：FineCoach; Required:true *    DicValue Desc:值 Required:false *    DicDesc Desc:描述 Required:false *    Sort Desc:排序 Required:false *    ParentId Desc:父ID(后台使用) Required:false *    OrgId Desc:机构ID(后台使用) Required:false * } */async function _add(body) {  return request(baseUrl+'/add',{    method: 'POST',    body: body,  });
}

/** * 批量新增 * @param {*} body * { *    DicGroup Desc:标签分组 
优秀学生标签：FineStudent;
优秀教师标签：FineCoach; Required:true *    BranchId Desc:校区id Required:false *    DicValueList Desc:值 Required:false *    Sort Desc:排序 Required:false *    ParentId Desc:父ID(后台使用) Required:false *    OrgId Desc:机构ID(后台使用) Required:false * } */async function _batchAdd(body) {  return request(baseUrl+'/batchAdd',{    method: 'POST',    body: body,  });
}

/** * 更新 * @param {*} body * { *    OrgDictionaryId Desc: Required:false *    BranchId Desc:校区id Required:false *    DicGroup Desc:标签分组 
优秀学生标签：FineStudent;
优秀教师标签：FineCoach; Required:true *    DicValue Desc:值 Required:false *    DicDesc Desc:描述 Required:false *    Sort Desc:排序 Required:false *    ParentId Desc:父ID(后台使用) Required:false *    OrgId Desc:机构ID(后台使用) Required:false * } */async function _update(body) {  return request(baseUrl+'/update',{    method: 'POST',    body: body,  });
}

/** * 删除 * @param {*} param * { *    orgDictionaryId Desc: Required:true * } */async function _delete(param) {  return request(baseUrl+'/delete',{    method: 'GET',    params: param,  });
}

/** * 批量删除 * @param {*} body * { *    IdList Desc:IDList Required:false *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false * } */async function _batchDelete(body) {  return request(baseUrl+'/batchDelete',{    method: 'POST',    body: body,  });
}

/** * 贴标签时用的列表查询(不分页)
禁用的不包括在内 * @param {*} body * { *    DicGroup Desc:标签分组
老师：FineCoach
学员：FineStudent
客户表单：CustomerForm
学员表单：StudentForm
培训类型：TrainType
课程类别: CourseType
现金支付场景: CashPayPayScene Required:false *    OrgId Desc:机构id（后台使用，匿名方法时传） Required:false *    IsDisable Desc:是否禁用（后台使用） Required:false *    BranchId Desc:校区id Required:false * } */async function _getList(body) {  return request(baseUrl+'/getList',{    method: 'POST',    body: body,  });
}

/** * 基础设置里用的列表查询（不分页）
禁用的也包括在内 * @param {*} body * { *    DicGroup Desc:标签分组
老师：FineCoach
学员：FineStudent
客户表单：CustomerForm
学员表单：StudentForm
培训类型：TrainType
课程类别: CourseType
现金支付场景: CashPayPayScene Required:false *    OrgId Desc:机构id（后台使用，匿名方法时传） Required:false *    IsDisable Desc:是否禁用（后台使用） Required:false *    BranchId Desc:校区id Required:false * } */async function _getAllList(body) {  return request(baseUrl+'/getAllList',{    method: 'POST',    body: body,  });
}

/** * 上移一条数据 * @param {*} param * { *    orgDictionaryId Desc:标签ID Required:true *    dicGroup Desc:分组 Required:true * } */async function _moveUp(param) {  return request(baseUrl+'/moveUp',{    method: 'GET',    params: param,  });
}

/** * 下移一条数据 * @param {*} param * { *    orgDictionaryId Desc:标签ID Required:true *    dicGroup Desc:分组 Required:true * } */async function _moveDown(param) {  return request(baseUrl+'/moveDown',{    method: 'GET',    params: param,  });
}

export default{  _add,  _batchAdd,  _update,  _delete,  _batchDelete,  _getList,  _getAllList,  _moveUp,  _moveDown}



// WEBPACK FOOTER //
// ./src/services/orgDictionary.js